import React, { useContext } from 'react';
import Inicio from '../components/pages/Inicio';
import ResetPasswordSL from '../components/pages/ResetPassword/SendLink';
import ResetPasswordFU from '../components/pages/ResetPassword/FormUpdate';
import Dashboard from '../components/pages/Dashboard';
import { BrowserRouter as Router,Switch ,Route } from "react-router-dom";
import { SesionContext } from '../context/SesionContext';
import { ValidateContext } from '../context/ValidateContext';
import Loader from "../components/globals/Loader";

function Routes() {
  const { isAuth } = useContext(SesionContext);
  const { validando } = useContext(ValidateContext);
  if(!validando){
    return (
      //Aqui van todas las rutas como ahorita es una SPA solo llamamos al dashboard
      isAuth ?(
        <Router>
          <Switch>
            <Route path="/" component={()=><Dashboard authorized={isAuth}/>}></Route>
          </Switch>
        </Router>
      
      ):(
        <Router>
          <Switch>
            <Route exact path="/" component={Inicio}></Route>
            <Route path="/reset_password" component={ResetPasswordSL}></Route>
            <Route exact path="/reset_password_update/:token" component={ResetPasswordFU}></Route>
            <Route exact path="*" component={Inicio}></Route>{/**Ruta default 404 */}
          </Switch>
        </Router>
      )
    );
  }
  else{
    return (
      <div id="laoding" style={{height: '100vh'}}>
        <Loader />
      </div>
    );
  }
  
}

export default Routes;